export default __webpack_public_path__ + "static/media/slider-card.3850f72f.png";